import { render } from "./LRPChart.vue?vue&type=template&id=f65766da&scoped=true"
import script from "./LRPChart.vue?vue&type=script&lang=js"
export * from "./LRPChart.vue?vue&type=script&lang=js"

import "./LRPChart.vue?vue&type=style&index=0&id=f65766da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65766da"]])

export default __exports__